

























import Vue, { PropType } from 'vue'
import TreeNode from '@/pages/bank/lesson-tasks/list/parts/lessons-tree/TreeNode.vue'
import NoDataContent from '@/pages/common/parts/no-data-content/NoDataContent.vue'
import { $lessonsTree } from '@/pages/bank/lesson-tasks/list/lesson-page.model'
import { FiltersParams } from '@/pages/common/types'

export default Vue.extend({
  name: 'TasksTree',
  components: {
    TreeNode,
    NoDataContent,
  },
  props: {
    filters: { type: Object as PropType<FiltersParams> },
  },
  effector: { $lessonsTree },
})
